import { render, staticRenderFns } from "./LuAgency.vue?vue&type=template&id=4b607090"
import script from "./LuAgency.vue?vue&type=script&lang=js"
export * from "./LuAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports